import { useEffect, useRef } from 'react';
import { Button, Icon, BaseControl } from '@wordpress/components';
import { closeSmall } from '@wordpress/icons';

const ImagePicker = ({ field, value, onChange }) => {
    const safeValue = value && value.id ? value : {};
    const requestedSize = field.image_size || 'full';
    const mediaFrame = useRef(null);

    const getImageUrl = (media) => {
        if (!media) return '';
        if (media.sizes && media.sizes[requestedSize]) {
            return media.sizes[requestedSize].url;
        }
        if (media.sizes) {
            const match = Object.values(media.sizes).find(
                (size) => `${size.width}x${size.height}` === requestedSize
            );
            if (match) return match.url;
        }
        return media.url || '';
    };

    const openMediaLibrary = () => {
        if (mediaFrame.current) {
            mediaFrame.current.open();
            return;
        }

        mediaFrame.current = wp.media({
            title: 'Select or Upload Image',
            button: {
                text: 'Use this image',
            },
            library: {
                type: 'image',
            },
            multiple: false,
        });

        mediaFrame.current.on('select', () => {
            const media = mediaFrame.current.state().get('selection').first().toJSON();
            const imageUrl = getImageUrl(media);
            onChange({
                id: media.id,
                url: imageUrl,
            });
        });

        mediaFrame.current.open();
    };

    const handleRemove = () => onChange(undefined);

    return (
        <BaseControl label={field.label} __nextHasNoMarginBottom>
            <div className="voxy-component">
                <div className="image-selector">
                    <div className="image-selector__preview" onClick={openMediaLibrary}>
                        {safeValue.url ? (
                            <>
                                <img src={safeValue.url} alt="Selected" />
                                <Button
                                    className="image-selector__remove"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleRemove();
                                    }}
                                    icon={closeSmall}
                                    label="Remove Image"
                                />
                            </>
                        ) : (
                            <div className="image-selector__placeholder">+</div>
                        )}
                    </div>
                    <Button
                        onClick={openMediaLibrary}
                        className="image-selector__change-btn"
                        variant="secondary"
                    >
                        {safeValue.url ? 'Change Image' : 'Upload Image'}
                    </Button>
                </div>
            </div>
        </BaseControl>
    );
};

export default ImagePicker;
